import moment from "moment";
import get from "lodash/get";

/**
 * Transforms a raw attachment object into object compatible with apollo cache.
 *
 * @param {object | null} originalAttachment The raw attachment from the message.
 * @returns {object | null} The transformed attachment or null.
 */
export function transformAttachment(originalAttachment) {
    if (!originalAttachment || typeof originalAttachment !== "object") {
        return null;
    }

    const originalPayload = originalAttachment.payload;
    let payload = originalPayload;

    if (originalPayload && typeof originalPayload === "object") {
        payload = {
            ...originalPayload,
            __typename: "PayloadField",
            templateType: originalPayload.templateType ?? originalPayload.template_type ?? null,
            relativePath: originalPayload.relativePath ?? originalPayload.relative_path ?? null,
        };
    }

    return {
        ...originalAttachment,
        __typename: "AttachmentField",
        payload,
    };
}
/**
 * createApolloMessage is used to create apollo cache compatible message
 * object with all the correct __typenames, and rest of the required fields
 *
 * @export
 * @param {*} message object received over the pusher websocket
 * @returns apollo cache compatible object
 */
export default function createApolloMessage(message) {
    const richContent = !message.richContent
        ? null
        : {
              reply: {
                  ...message.richContent.reply,
                  originalMessageText: message.richContent.reply.messageText || "",
                  __typename: "ReplyOutputField",
              },
              __typename: "RichContentOutputField",
          };

    const returned = {
        __typename: "MessageField",
        id: message.id,
        created: moment
            .utc(message.created || message.createdAt)
            .local()
            .toISOString()
            .replace("Z", ""),
        text: message.text,
        sender: {
            __typename: "AnyUserField",
            id: get(message, "sender.id", ""),
            firstName: get(message, "sender.firstName", ""),
            accountRole: get(message, "sender.accountRole", ""),
            profilePhoto: get(message, "sender.profilePhoto", ""),
            country: {
                __typename: "CountryField",
                id: get(message, "sender.country.id", ""),
                name: get(message, "sender.country.name", ""),
            },
            university: {
                __typename: "UniversityField",
                id: get(message, "sender.university.id", ""),
                name: get(message, "sender.university.name", ""),
            },
        },
        richContent,
        chatGroupId: message.chatGroupId,
        likes: get(message, "likes", []),
        visible: "",
        read: get(message, "read", false),
        deleted: get(message, "deleted", false),
        isSenderBlocked: get(message, "isSenderBlocked", false),
        attachment: transformAttachment(message.attachment),
    };
    return returned;
}
